import { cn } from '../lib/cn.js';

export interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  /** Optional mono label centred in a horizontal divider. */
  label?: string;
  /** --hair (default) or --line. */
  weight?: 'hair' | 'line';
  className?: string;
}

/** 1px rule. Horizontal fills width; vertical fills the parent's height (h-3 inline by default). */
export function Divider({ orientation = 'horizontal', label, weight = 'hair', className }: DividerProps) {
  const color = weight === 'hair' ? 'bg-hair' : 'bg-line';
  if (orientation === 'vertical') {
    return <span role="separator" aria-orientation="vertical" className={cn('inline-block h-3 w-px shrink-0', color, className)} />;
  }
  if (label) {
    return (
      <div role="separator" className={cn('flex items-center gap-3', className)}>
        <span className={cn('h-px flex-1', color)} />
        <span className="label-mono">{label}</span>
        <span className={cn('h-px flex-1', color)} />
      </div>
    );
  }
  return <hr className={cn('h-px w-full border-0', color, className)} />;
}
